<template>
  <div>
    <div class="options">
      <div>
        <RadioButton
          name="optout"
          label="SHOWROOM_ADMIN.AI_OPT_OUT.ALL.LABEL"
          :selected="optOutValue === 'ALL'"
          @on-selected="setOptOut('ALL')"
        />
        <HelpLink
          v-tooltip.bottom-start="{
            content: $t('SHOWROOM_ADMIN.AI_OPT_OUT.ALL.HINT'),
            triggers: ['click', 'touch'],
            autoHide: true,
            delay: 0,
          }"
          href="#"
          icon-only
          @click.prevent
        />
        <Badge type="neutral" class="ml-2">
          {{ $t('GENERAL.RECOMMENDED') }}
        </Badge>
      </div>
      <div>
        <RadioButton
          name="optout"
          label="SHOWROOM_ADMIN.AI_OPT_OUT.NONE.LABEL"
          :selected="optOutValue === 'NONE'"
          @on-selected="setOptOut('NONE')"
        />
        <HelpLink
          v-tooltip.bottom-start="{
            content: $t('SHOWROOM_ADMIN.AI_OPT_OUT.NONE.HINT'),
            triggers: ['click', 'touch'],
            autoHide: true,
            delay: 0,
          }"
          href="#"
          icon-only
          @click.prevent
        />
      </div>
    </div>
    <div>
      <button
        class="btn btn-primary"
        :disabled="!isDirty"
        @click="saveSettings"
      >
        {{ $t('GENERAL.SAVE') }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import RadioButton from 'commons/RadioButtonGroup/RadioButton.vue';
import Badge from 'src/app/components/badge/Badge.vue';
import HelpLink from 'commons/helpLink/HelpLink.vue';
import { useToastsStore } from 'commons/stores/toasts';
import { i18n } from 'commons/translate/i18n';
import publishingCoreService, {
  aiOptOutKey,
  AiOptOutValue,
} from 'commons/api/publishingCoreService/publishingCoreService';
import store from 'commons/store/Store';

const { t } = i18n.global;
const toastsStore = useToastsStore();
const optOutValue = ref<AiOptOutValue>(
  store.getters['settings/getSetting'](aiOptOutKey),
);
const optOutOriginal = ref<AiOptOutValue>(optOutValue.value);
const isDirty = computed(() => optOutValue.value !== optOutOriginal.value);

const setOptOut = (value: AiOptOutValue) => {
  optOutValue.value = value;
};

const saveSettings = async () => {
  await publishingCoreService.setAiOptOut(optOutValue.value);

  store.dispatch('settings/fetchSettings');
  toastsStore.addToast({
    variant: 'success',
    text: t('SHOWROOM_ADMIN.AI_OPT_OUT.SAVE_SUCCESS'),
    hideIcon: true,
    dismissible: true,
    timeout: 8000,
  });
};
</script>

<style lang="scss" scoped>
.options {
  display: flex;
  flex-direction: column;
  gap: 16px;

  & > div {
    display: flex;
    align-items: center;
    gap: 8px;

    label {
      margin: 0;
    }
  }
}

.btn {
  padding: 8px 24px;
  min-width: 120px;
  margin-top: 24px;
}
</style>
